{
  "community": {
    "name": "Community",
    "titles": {
      "1": "Online community",
      "2": "Find materials",
      "3": "Share what you've created"
    },
    "body": {
      "1": "A great place to jump in and check out all that Boardmaker offers",
      "2": "See what others are creating and sharing. It's like a window in to the Boardmaker Magic!",
      "3": "Using your preferred Boardmaker software, upload and share what you've created with the community"
    }
  },
  "personal": {
    "name": "Personal",
    "header": "Includes all of Community, plus:",
    "titles": {
      "1": "Create, edit, play, and print",
      "2": "Boardmaker software"
    },
    "body": {
      "1": "For a parent or caregiver with one child, wanting to create, edit, play, and print activities",
      "2": "Accounts come with a Boardmaker 7 license that can be installed on up to 2 Windows computers"
    }
  },
  "professional": {
    "name": "Professional",
    "header": "Includes all of Personal, plus:",
    "titles": {
      "1": "Student management",
      "2": "Individualized settings"
    },
    "body": {
      "1": "For instructors with 1 to 50 students, wanting to assign tasks and track student data",
      "2": "Customized access settings for individual students"
    }
  },
  "organization": {
    "name": "Organization",
    "header": "Includes all of Professional, plus:",
    "titles": {
      "1": "Multidisciplinary team support"
    },
    "body": {
      "1": "Volume pricing, organization controls the information and multiple people can assign to the same students"
    }
  }
}
